<div class="p500-ui-form-field" *ngIf="!(unsecuredStatus$ | async).isUnsecured; else form">
  <label class="p500-ui-form-field__inner">
    <div class="p500-ui-form-field__input">
      <gtd-ui-field-default-protected [afterClosed]="afterClosed"></gtd-ui-field-default-protected>
    </div>
    <span class="p500-ui-form-field__label-inner">
      <span class="p500-ui-form-field__label"> {{ label }} </span>
    </span>
  </label>
</div>
<ng-template #form>
  <ng-container [ngSwitch]="format">
    <p500-ui-text-field *ngSwitchCase="'text'" [formControl]="control" [label]="label"></p500-ui-text-field>
    <p500-ui-text-field *ngSwitchCase="'email'" [formControl]="control" [label]="label"></p500-ui-text-field>
    <p500-ui-number-field *ngSwitchCase="'number'" [formControl]="control" [label]="label"></p500-ui-number-field>
    <p500-ui-number-field *ngSwitchCase="'money'" [formControl]="control" [label]="label"></p500-ui-number-field>
    <p500-ui-datepicker-field-new *ngSwitchCase="'date'" [formControl]="control" [label]="label"></p500-ui-datepicker-field-new>
    <p500-ui-boolean-select-field *ngSwitchCase="'boolean'" [formControl]="control" [label]="label"></p500-ui-boolean-select-field>
    <p500-ui-text-field *ngSwitchDefault [formControl]="control" [label]="label"></p500-ui-text-field>
  </ng-container>
</ng-template>
